import React from 'react';
import { LoginLayout } from 'components/layouts/LoginLayout';
import { ForgotContent } from 'components/organisms/Contents/ForgotContent';

const Forgot = () => {
  return (
    <LoginLayout>
      <ForgotContent />
    </LoginLayout>
  );
};
export default Forgot;
